// extracted by mini-css-extract-plugin
module.exports = {"icon":"CopyIcon_icon_j5D3u"};